export interface TickerMetrics {
  repeats: number;
  groupWidth: number;
  duration: number;
}

/** İki özdeş marquee grubunun ortak ölçülerini hesaplar. */
export function tickerMetrics(
  viewportWidth: number,
  itemWidth: number,
  gap = 48,
  speed = 52,
): TickerMetrics {
  const repeats = Math.max(2, Math.ceil(viewportWidth / (itemWidth + gap)) + 1);
  const groupWidth = repeats * (itemWidth + gap);
  return { repeats, groupWidth, duration: Math.max(6, groupWidth / speed) };
}
